module App.Model

open Fable.Import.ReactVirtualized

type Model =
    { Dialects: obj []
      SelectedDialectId1: string
      SelectedDialectId2: string
      Words1: obj []
      Words2: obj []
      WordFilter1: string
      WordFilter2: string
      WordTableSort1: SortArg
      WordTableSort2: SortArg }


// WEBPACK FOOTER //
// src/Model.fs